import { Component, HostBinding } from '@angular/core';
import { SessionService } from './session.service';

@Component({
  selector: 'app-terms-page',
  standalone: true,
  imports: [],
  templateUrl: './terms.page.html',
})
export class TermsPage {
    @HostBinding('class') css = 'max-height';

  constructor(private session: SessionService) {}
  ngOnInit() {}
}
